module.exports = __webpack_public_path__ + "img/36_72.c75ebba9.png";